import LtSpiceConsts from '../utils/lt-spice';

export default {
    templateToFilesMappings: [
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.READ
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.READ,
            fileType: 'txt'
        },
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.DRIVER
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.DRIVER,
            fileType: 'asc'
        },
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.DRIVER
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.DRIVER,
            fileType: 'asy'
        },
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.ADC
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.ADC,
            fileType: 'asc',
            conditional: (data) => { return !data.isADCInLTSpice }
        },
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.ADC
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.ADC,
            fileType: 'asy',
            conditional: (data) => { return !data.isADCInLTSpice }
        },
        {
            // TRANSIENT
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.TITLE_AND_POWER_TRANSIENT,
                    numRemoveTopLines: 0,
                    numRemoveBottomLines: 0
                },
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.DRIVER_AND_SOURCE,
                    numRemoveTopLines: 2,
                    numRemoveBottomLines: 0
                },
                {
                    name: (data) => {
                        return data.isADCInLTSpice ?
                            LtSpiceConsts.TEMPLATE_NAMES.ADC_AND_RC_TRANSIENT_LT_SPICE :
                            LtSpiceConsts.TEMPLATE_NAMES.ADC_AND_RC_TRANSIENT;
                    },
                    numRemoveTopLines: 2,
                    numRemoveBottomLines: (data) => {
                        return data.hasHiZ ? 0 : 2
                    }
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.TRANSIENT,
            replacements: {
                vdiff: (data) => { return data.transientVdiff }
            },
            fileType: 'asc'
        },
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.TRANSIENT
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.TRANSIENT,
            fileType: 'plt'
        },
        {
            // MUXED TRANSIENT
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.TITLE_AND_POWER_MUXED_TRANSIENT,
                    numRemoveTopLines: 0,
                    numRemoveBottomLines: 0
                },
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.DRIVER_AND_SOURCE_MUXED,
                    numRemoveTopLines: 2,
                    numRemoveBottomLines: 0
                },
                {
                    name: (data) => {
                        return data.isADCInLTSpice ?
                            LtSpiceConsts.TEMPLATE_NAMES.ADC_AND_RC_TRANSIENT_LT_SPICE :
                            LtSpiceConsts.TEMPLATE_NAMES.ADC_AND_RC_TRANSIENT;
                    },
                    numRemoveTopLines: 2,
                    numRemoveBottomLines: (data) => {
                        return data.hasHiZ ? 0 : 2
                    }
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.MUXED,
            replacements: {
                vdiff: (data) => { return data.pulseOp }
            },
            fileType: 'asc',
            conditional: (data) => { return data.isMultiplexed; }
        },
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.MUXED
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.MUXED,
            fileType: 'plt',
            conditional: (data) => { return data.isMultiplexed }
        },
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.TITLE_AND_POWER_NOISE,
                    numRemoveTopLines: 0,
                    numRemoveBottomLines: 0
                },
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.DRIVER_AND_SOURCE,
                    numRemoveTopLines: 2,
                    numRemoveBottomLines: 0
                },
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.ADC_AND_RC_NOISE,
                    numRemoveTopLines: 2,
                    numRemoveBottomLines: 0
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.NOISE,
            fileType: 'asc',
            replacements: {
                ro: (data) => { return data.ro || data.ro === 0 ? `${data.ro} noiseless` : ''},
                vdiff: (/*data*/) => { return 0 }
            }
        },
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.NOISE
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.NOISE,
            fileType: 'plt'
        },
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.TITLE_AND_POWER_OPRANGE,
                    numRemoveTopLines: 0,
                    numRemoveBottomLines: 0
                },
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.DRIVER_AND_SOURCE,
                    numRemoveTopLines: 2,
                    numRemoveBottomLines: 0
                },
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.ADC_AND_RC_NOISE,
                    numRemoveTopLines: 2,
                    numRemoveBottomLines: 0,
                    overrides: {
                        noise_out: 'driver_out'
                    }
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.OPRANGE,
            fileType: 'asc',
            replacements: {
                vdiff: (data) => { return data.opRangeVdiff }
            }
        },
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.OPRANGE
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.OPRANGE,
            fileType: 'plt'
        },
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.ADC_AND_RC_FFT,
                    numRemoveTopLines: 0,
                    numRemoveBottomLines: 0
                },
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.DRIVER_AND_SOURCE,
                    numRemoveTopLines: 2,
                    numRemoveBottomLines: 0
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.FFT,
            fileType: 'asc',
            replacements: {
                vdiff: (data) => { return data.thdFFTVdiff }
            },
            conditional: (data) => { return data.isFFTLTSpice }
        },
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.FFT
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.FFT,
            fileType: 'plt',
            conditional: (data) => { return data.isFFTLTSpice }
        },
        {
            in: [
                {
                    name: LtSpiceConsts.TEMPLATE_NAMES.TOOL
                }
            ],
            out: LtSpiceConsts.FILE_NAMES.TOOL,
            fileType: 'url'
        }
    ],
}
